const formatDevice = (device) => device.deviceId ? { id: device.deviceId, value: device.label || device.deviceId } : null;
export const getDevices = async () => {
    const mediaDevices = await navigator.mediaDevices.enumerateDevices();
    const microphones = mediaDevices.filter(({ kind, deviceId }) => deviceId && kind === 'audioinput').map(formatDevice);
    const cameras = mediaDevices.filter(({ kind, deviceId }) => deviceId && kind === 'videoinput').map(formatDevice);
    const speakers = mediaDevices.filter(({ kind, deviceId }) => deviceId && kind === 'audiooutput').map(formatDevice);
    return { cameras, microphones, speakers };
};
export const onDevicesChanged = (callback) => {
    const onDeviceChange = () => getDevices().then(callback);
    void onDeviceChange();
    try {
        navigator.mediaDevices.addEventListener('devicechange', onDeviceChange);
    }
    catch (e) {
        console.log(e);
        return () => { };
    }
    return () => navigator.mediaDevices.removeEventListener('devicechange', onDeviceChange);
};
//# sourceMappingURL=media-permissions.js.map